import { UserService } from './../../../services/user.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { PaymentService } from '../../../services/payment.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { first, map, tap, concatMap } from 'rxjs/operators';
import * as jquery from 'jquery';
import { UserNavigationComponent } from 'src/app/partials/navigation/user-navigation/user-navigation.component';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {

  @ViewChild(UserNavigationComponent) userNavigation;

  loading = false;
  success = false;
  error = false;
  cancel_date: number;
  modalText = 'Loading...';
  subscriptionAmount: any;

  cancelForm: FormGroup;
  submitted = false;

  constructor(
    private route: ActivatedRoute,
    private pageTitleService: Title,
    private paymentService: PaymentService,
    private formBuilder: FormBuilder,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.setPageTitle();
    this.setFormControls();

    this.loadData();

    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Change Subscription');
  }

  setFormControls() {
    this.cancelForm = this.formBuilder.group({
      password: ['', [Validators.required]]
    });
  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    this.userService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.userNavigation.user = user;
        }),

        // Get Active Subscription
        concatMap(() => this.paymentService.getActiveSubscription()),
        map(plan => plan.data),
        tap(plan => {
          this.subscriptionAmount = plan.subscription.amount;
          if (plan.subscription.cancelled !== '') {
            this.cancel_date = plan.subscription.cancelled;
          }
        })

      )
      .subscribe(
        response => {
          if (response) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  // convenience getter for easy access to form fields
  get f() { return this.cancelForm.controls; }

  resetForm() {
    this.submitted = false;
    this.cancelForm.reset();
  }

  onCancelPlan() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.cancelForm.invalid) {
      return;
    }

    this.loading = true;
    this.success = false;
    this.paymentService.cancelSubscription(this.f.password.value)
      .pipe(first())
      .subscribe(data => {
        if (data.success) {
          jquery('.close').click();
          this.success = true;
          this.loadData();
          setTimeout(() => {
            this.success = false;
          }, 4000);
        } else {
          this.submitted = true;
          this.f.password.setErrors({'error': true});
          this.f.password.setErrors({'invalid': true});
        }
        this.loading = false;
      });
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
